// extracted by mini-css-extract-plugin
module.exports = {"page":"OpenApp_page__2mnG4","miniqrcode":"OpenApp_miniqrcode__2vPwB","tips":"OpenApp_tips__33j6y"};